<template>
    <div class="b-content">
        <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(item,index) in colorTarArr" :key="item.code" :class="{'swiper-slide-active-item':item.code === selectInterCode}">
                <div class="slide-content swiper-no-swiping" @click="switchColor(index, item.code)">
                    <div class="color">
                        <div class="color-inner" :style="{background:`${item.color}`}">
                            <template v-if="Array.isArray(item.color)">
                                <span class="img-child" v-for="c in item.color" :key="c" :style="{background:`${c}`}"></span>
                            </template>
                        </div>
                    </div>
                    <div class="name">{{ item.name }}</div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
        <div class="number360d"></div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import requireJson from "@/utils/requireJson";

export default {
    name: "outer",
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        },
        ...mapGetters(['selectTypeItem']),
        ...mapState({
            selectInterCode: state => state.selectInterCode,
            carConfig: state => state.carConfig,
            interArr: state => state.interArr,
        }),
        colorTarArr: vm =>
            vm.interArr.map(code => ({
                code,
                ...((vm.carConfig.interTypeArr && vm.carConfig.interTypeArr[code]) || vn.globalInterTypeArr.find(o => o.code === code))
            }))
    },
    // watch: {
    //   interArr: {
    //     handler() {
    //       this.colorTarArr = this.interArr.map(code => {
    //         let data = {
    //           code,
    //           ...((this.carConfig.interTypeArr && this.carConfig.interTypeArr[code]) || interTypeArr.find(o => o.code === code))
    //         }
    //         return data
    //       })
    //     },
    //     immediate: true
    //   }
    // },
    mounted() {
        const index = this.interArr.findIndex(o => o === this.selectInterCode)
        console.log(index)
        this.swiper.slideTo(index);

        requireJson('inter.json').then(globalInterTypeArr => {
            this.globalInterTypeArr = globalInterTypeArr
        })
    },
    data() {
        return {
            swiperOptions: {
                slidesPerView: '8',//显示个数
                direction: 'horizontal',
                centerInsufficientSlides: true,
                breakpoints: {
                    768: {  //当屏幕宽度大于等于768
                        slidesPerView: 4,
                    }
                },
                normalizeSlideIndex: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                noSwiping: true
            },
            globalInterTypeArr: []
        }
    },
    methods: {
        ...mapActions(['setSelectInterCode']),
        switchColor(index, code) {
            console.log(index, code)
            this.swiper.slideTo(index);
            this.setSelectInterCode(code)
        }
    }
}
</script>

<style scoped>

</style>
